import { UserReferralStats } from '@chiroup/core/types/Referral.type';
import { useQuery } from 'react-query';
import referralService, { ReferralOverviewResponse } from '../services/referral.service';

export const useReferralOverview = (startDate?: string, endDate?: string) =>
  useQuery<ReferralOverviewResponse>(
    ['referral-overview', startDate, endDate],
    () => referralService.overview(startDate, endDate),
    { refetchOnWindowFocus: false, staleTime: 60 * 1000 }
  );

export const useUserReferrals = (userId?: string) =>
  useQuery<UserReferralStats>(
    ['user-referrals', userId],
    () => referralService.userReferrals(userId as string),
    { refetchOnWindowFocus: false, enabled: !!userId, staleTime: 60 * 1000 }
  );
